export class NewsAttachment {
    attachment_id: number;
    news_id: number;
    media_url: string;
}